(function () {
  'use strict';

  function formatMoney(amount, currency) {
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency || 'USD',
        maximumFractionDigits: 0
      }).format(amount);
    } catch (e) {
      return '$' + Math.round(amount).toLocaleString();
    }
  }

  function initConfigurator(root) {
    var basePrice = parseFloat(root.dataset.basePrice || '0');
    var currency = root.dataset.currency || 'USD';
    var sectionId = root.dataset.sectionId;

    var form = root.querySelector('.sauna-configurator__form');
    if (!form) return;

    var summaryBase = root.querySelector('[data-summary-base]');
    var summaryList = root.querySelector('[data-summary-list]');
    var summaryTotal = root.querySelector('[data-summary-total]');

    var selectionsInput = document.getElementById('ConfiguratorSelectionsInput-' + sectionId);
    var summaryInput = document.getElementById('ConfiguratorSummaryInput-' + sectionId);
    var totalInput = document.getElementById('ConfiguratorTotalInput-' + sectionId);
    var paymentPrefInput = document.getElementById('ConfiguratorPaymentPrefInput-' + sectionId);

    function getSelectedInputs() {
      return Array.prototype.slice.call(
        form.querySelectorAll('.configurator-group input[type="radio"]:checked, .configurator-group input[type="checkbox"]:checked')
      );
    }

    function getGroupLabel(group) {
      var legend = group.querySelector('.configurator-group__legend span');
      return legend ? legend.textContent.trim() : (group.dataset.groupId || '');
    }

    function getOptionLabel(input) {
      var option = input.closest('.configurator-option');
      var labelEl = option ? option.querySelector('.configurator-option__label') : null;
      return labelEl ? labelEl.textContent.trim() : input.value;
    }

    function recalc() {
      var selected = getSelectedInputs();
      var addOnTotal = 0;
      var lines = [];
      var selectionSummaryParts = [];
      var selectionIds = [];

      selected.forEach(function (input) {
        var group = input.closest('.configurator-group');

        if (group && group.dataset.groupType === 'payment_preference') {
          if (paymentPrefInput) paymentPrefInput.value = input.value;
          return;
        }

        var delta = parseFloat(input.dataset.priceDelta || '0');
        var optionLabel = getOptionLabel(input);

        selectionIds.push(input.value);

        if (group && group.dataset.groupType !== 'info_list') {
          selectionSummaryParts.push(getGroupLabel(group) + ': ' + optionLabel);
        }

        if (delta !== 0) {
          addOnTotal += delta;
          lines.push({ label: optionLabel, delta: delta });
        }
      });

      var total = basePrice + addOnTotal;

      if (summaryList) {
        summaryList.innerHTML = '';
        lines.forEach(function (line) {
          var li = document.createElement('li');
          li.className = 'configurator-summary__line';

          var labelSpan = document.createElement('span');
          labelSpan.textContent = line.label;

          var deltaSpan = document.createElement('span');
          deltaSpan.textContent = '+' + formatMoney(line.delta, currency);

          li.appendChild(labelSpan);
          li.appendChild(deltaSpan);
          summaryList.appendChild(li);
        });
      }

      if (summaryBase) summaryBase.textContent = formatMoney(basePrice, currency);
      if (summaryTotal) summaryTotal.textContent = formatMoney(total, currency);

      if (selectionsInput) selectionsInput.value = JSON.stringify(selectionIds);
      if (summaryInput) summaryInput.value = selectionSummaryParts.join(' | ');
      if (totalInput) totalInput.value = formatMoney(total, currency);
    }

    form.addEventListener('change', function (event) {
      var group = event.target.closest ? event.target.closest('.configurator-group') : null;
      if (!group) return;

      var option = event.target.closest('.configurator-option');
      if (option) {
        if (event.target.type === 'radio') {
          group.querySelectorAll('.configurator-option').forEach(function (opt) {
            opt.classList.remove('is-selected');
          });
        }
        option.classList.toggle('is-selected', event.target.checked);
      }
      recalc();
    });

    form.addEventListener('submit', recalc);

    recalc();
  }

  function initGallery(root) {
    var thumbs = root.querySelectorAll('.sauna-configurator-page__thumb');
    var mainMediaWrap = root.querySelector('.sauna-configurator-page__media-main');
    if (!thumbs.length || !mainMediaWrap) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var thumbImg = thumb.querySelector('img');
        var mainImg = mainMediaWrap.querySelector('img');
        if (!thumbImg || !mainImg) return;

        var newSrc = thumbImg.currentSrc || thumbImg.src;
        mainImg.removeAttribute('srcset');
        mainImg.src = newSrc.replace(/width=\d+/, 'width=1500');

        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.sauna-configurator').forEach(initConfigurator);
    document.querySelectorAll('.sauna-configurator-page').forEach(initGallery);
  });
})();
